import React, { useCallback, useState } from 'react'
import { Progress } from 'antd'
import { floor } from 'lodash'

export const UploadingView = ({ progress }) => {
  return (
    <>
      <Progress type='circle' percent={floor(progress, 0)} />
    </>
  )
}
